import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Report, RunReportRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useRunReport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RunReportRequest) => apiPost<Report>('/v1/reports/run', input),
    onSuccess: (report) => {
      void qc.invalidateQueries({ queryKey: ['reports'] });
      qc.setQueryData(['report', report.id], report);
    },
  });
}
